import { useState, useContext } from 'react';
import { ModalContext, AppContext } from 'commons-ui';
import useService from '../../useService';
import { IContentProps, IFormData } from '../../types';

const useLinkAccount = (props: IContentProps) => {
	const { linkBankDetails } = useService();
	const [showLoader, setShowLoader] = useState(false);
	const { setModalConfig } = useContext(ModalContext);
	const { showAlert } = useContext(AppContext);

	const handleFormSubmit = async (submittedData: IFormData) => {
		try {
			setShowLoader(true);
			await linkBankDetails(props, submittedData);
			setShowLoader(false);
		} catch (error: any) {
			showAlert(error.message || 'Error in activating account.', { type: 'error' });
		} finally {
			setModalConfig({ isOpen: false });
		}
	};

	const handleFormCancel = () => {
		setModalConfig({ isOpen: false });
	};

	return {
		showLoader,
		setShowLoader,
		handleFormCancel,
		handleFormSubmit
	};
};

export default useLinkAccount;
